import { call, all, put, takeLatest } from "redux-saga/effects";

import {
  getSurveysSuccess,
  getSurveysFail,
  surveyApprovalSuccess,
  surveyApprovalFail,
} from "../actionCreators/Survey";
import { doGet, doPost } from "../utils/request";

function* getSurveys({ obj }) {
  try {
    const response = yield doGet(
      `/surveys/all?page=${obj.page}&pageSize=${obj.pageSize}&user_id=${obj.user_id}`
    );

    yield put(getSurveysSuccess(response.data));
  } catch (err) {
    yield put(getSurveysFail(err.response.data.message || err.message));
    yield put(getSurveysFail());
  }
}

function* surveyApproval({ obj }) {
  try {
    const response = yield doPost(`/surveys/approval`, obj);

    yield put(surveyApprovalSuccess(response.data));
  } catch (err) {
    yield put(surveyApprovalFail(err.response.data.message || err.message));
    yield put(surveyApprovalFail());
  }
}

export default function* watcher() {
  yield all([
    takeLatest("GET_SURVEYS", getSurveys),
    takeLatest("SURVEY_APPROVAL", surveyApproval),
  ]);
}
